/** GoHighLevel's own app, where "Open in GoHighLevel" goes. */
export const GHL_APP_ORIGIN = 'https://app.gohighlevel.com'

/**
 * A contact's page in GoHighLevel, which lists their opportunities. Links go to
 * the contact rather than the opportunity: GoHighLevel has no stable page for
 * one opportunity on its own.
 */
export function ghlContactUrl(locationId: string, contactId: string): string {
  return `${GHL_APP_ORIGIN}/v2/location/${encodeURIComponent(locationId)}/contacts/detail/${encodeURIComponent(contactId)}`
}

/** The most opportunities one event links to: one couple's, across a venue's sub-accounts. */
export const GHL_MAX_LINKS_PER_EVENT = 5

/** The longest event-name format a company may set. */
export const GHL_NAME_FORMAT_MAX = 120

/** The most GoHighLevel pipelines a connection's funnel mapping names. */
export const GHL_FUNNEL_PIPELINES_MAX = 50

/**
 * A GoHighLevel Location ID from what an admin pasted: the ID itself, or any
 * GoHighLevel link that contains one (`…/v2/location/<id>/…`). Null when neither.
 *
 * A link is accepted because that is where the ID is easiest to find: it is in
 * the address bar of every page inside a sub-account.
 */
export function extractGhlLocationId(input: string): string | null {
  const trimmed = input.trim()
  const inLink = /\/location\/([A-Za-z0-9]{8,40})(?:[/?#]|$)/.exec(trimmed)
  if (inLink?.[1] !== undefined) return inLink[1]
  return /^[A-Za-z0-9]{8,40}$/.test(trimmed) ? trimmed : null
}
